import { TextField } from '@material-ui/core';
import React, { FunctionComponent } from 'react';

import Texto from '@infotrack/presentacion-componentes/texto';

import ITipoDocumento from 'Infotrack@Modelos/negocioRefactor/entidades/repositorio/ITipoDocumento';

interface ICampoTipoDocumentoDescripcionProps {
    deshabilitado: boolean;
    manejarCambioCampo: (nombreCampo: keyof ITipoDocumento, nuevoValor: ITipoDocumento[keyof ITipoDocumento]) => any;
    valor: string;
}

const CampoTipoDocumentoDescripcion: FunctionComponent<ICampoTipoDocumentoDescripcionProps> = ({
    deshabilitado,
    manejarCambioCampo,
    valor,
}) => (
    <TextField
        disabled={deshabilitado}
        fullWidth
        label={<Texto id="TiposDocumento.CampoTipoDocumentoDescripcion.Nombre" />}
        onChange={(event) => manejarCambioCampo('TipoDocumentoDescripcion', event.target.value)}
        required
        value={valor}
    />
);

export default CampoTipoDocumentoDescripcion;
